<script>
export default {
  name: 'landing',
  data () {
    return {
      blockstack: window.blockstack
    }
  },

  methods: {
    signIn () {
      const blockstack = this.blockstack
      blockstack.redirectToSignIn()
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      const blockstack = this.blockstack
      const origin = window.location.origin
      blockstack.redirectToSignIn(origin, origin + '/manifest.json', ['store_write', 'publish_data'])
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// Landing.vue?58591b5d